import React, { useState } from "react";
import { View, StyleSheet, ScrollView, Platform } from "react-native";
import Text from "../components_v2/TextFont";
import { connect } from "react-redux";
import { translate } from "../locales/translate";
import * as Actions from "../actions/SmartParkingActions";
import Theme from "../argon-ui/Theme";
import SmartParking, { ParkingLot } from "../viewModels/SmartParking";
import { IconButton } from "../components_v2/Buttons";
import { SmartParkingLot } from "./SmartParkingFormScreen";
import ModalBase from "../nativeBase-ui/ModalBase";
interface props {
  name: string;
  parkingLot: [];
}

const ParkingLotListScreen = (props: any) => {
  const [parkingLots, setParkingLots] = useState<ParkingLot[] | []>(
    props.navigation.state.params?.parkingLots
  );
  const updateParkingLotHandler = (parkingLot: ParkingLot) => {
    // console.log(parkingLot)
    props.navigation.state.params.updateParkingLot(parkingLot);
  };
  return (
    <View style={{ flex: 1 }}>
      <ScrollView style={{ padding: 5 }}>
        {parkingLots.length == 0 ? (
          <View
            style={{ flex: 1, justifyContent: "center", alignItems: "center" }}
          >
            <Text style={{ textAlign: "center" }}>
              {translate("app.emptyList")}
            </Text>
          </View>
        ) : (
          parkingLots?.map((item: any) => {
            return (
              <ParkingLotItem
                // smartParking={smartParking}
                updateParkingLot={(parkingLot: ParkingLot) =>
                  updateParkingLotHandler(parkingLot)
                }
                scenarioReducer={props.scenarioReducer}
                item={item}
                key={item.id}
              />
            );
          })
        )}
      </ScrollView>
    </View>
  );
};

export const ParkingLotItem = (props: any) => {
  const {
    name,
    parkingNumber,
    scenarioId,
    scenarioUId,
    status,
    id,
    parkingAreaId,
  } = props.item;

  // === Status parkingLot ===
  const dataParkingStatus = [
    {
      label: translate("smartParking.parkingStatusList.Available"),
      value: "Available",
    },
    {
      label: translate("smartParking.parkingStatusList.Occupying"),
      value: "Occupying",
    },
    {
      label: translate("smartParking.parkingStatusList.Occupied"),
      value: "Occupied",
    },
    {
      label: translate("smartParking.parkingStatusList.OutOfService"),
      value: "OutOfService",
    },
    {
      label: translate("smartParking.parkingStatusList.Reserved"),
      value: "Reserved",
    },
  ];
  const statusFilter = dataParkingStatus.filter((i: any) => {
    return i.value == status;
  });
  // const [SmartParking, setSmartParking] = useState<SmartParking>(
  //   props.AreaReducer.parkings
  // );
  const [openDropDown, setOpenDropDown] = useState(false);
  return (
    <View style={styles.lotItem}>
      {/* === badge Status === */}
      <View
        style={[
          {
            position: "absolute",
            top: 5,
            width: 8,
            height: 8,
            borderRadius: 5,
          },
          Platform.OS == "web" ? { right: 5 } : { left: 5 },
          status === "Occupied"
            ? { backgroundColor: Theme.COLORS.ERROR }
            : status === "OutOfService"
            ? { backgroundColor: Theme.COLORS.MUTED }
            : status === "Occupying"
            ? { backgroundColor: Theme.COLORS.ORANGE }
            : { backgroundColor: Theme.COLORS.SUCCESS },
        ]}
      />
      <View
        style={{
          justifyContent: "space-between",
          alignItems: "center",
          flexDirection: "row",
        }}
      >
        <View style={{}}>
          <Text style={styles.txt}>
            {translate("smartParking.parkingName")} : {name}
          </Text>
          <Text style={styles.txt}>
            {translate("smartParking.parkingNumber")} : {parkingNumber}
          </Text>
          <Text style={[styles.txt, { margin: 0 }]}>
            {translate("smartParking.parkingStatus")} :{" "}
            {translate(`smartParking.parkingStatusList.${status}`)}
          </Text>
          {/* <Text style={styles.txt}>
            {translate("smartParking.parkingStatus")} : {statusFilter[0].label}
          </Text> */}
        </View>
        <IconButton
          style={{
            width: 40,
            height: 40,
            borderRadius: 20,
            justifyContent: "center",
            alignItems: "center",
          }}
          onPress={() => {
            setOpenDropDown(!openDropDown);
          }}
          icon={{
            code: !openDropDown ? "\uf044" : "\uf148",
            style: {
              fontFamily: "FontAwesomeProLight",
              fontSize: 20,
              color: Theme.COLORS.DARK,
            },
          }}
        />
      </View>
      <ModalBase isOpen={openDropDown} onClose={() => setOpenDropDown(false)}>
        <SmartParkingLot
          editMode
          id={id}
          smartParking={props.smartParking}
          scenarios={props.scenarioReducer}
          parkingLotName={name}
          parkingAreaId={parkingAreaId}
          scenarioId={scenarioId}
          scenarioUId={scenarioUId}
          parkingLotNumber={parkingNumber}
          status={status}
          updateParkingLot={(parkingLot: ParkingLot) => {
            setOpenDropDown(false);
            props.updateParkingLot(parkingLot);
            // (parkingLot: ParkingLot) => {
            //   console.log(parkingLot);
            //   // setEditParkiingLot(parkingLot);
            // };
          }}
        />
      </ModalBase>
    </View>
  );
};
const styles = StyleSheet.create({
  lotItem: {
    backgroundColor: Theme.COLORS.WHITE,
    borderRadius: 5,
    padding: 15,
    // paddingHorizontal: 15,
    marginBottom: 8,
    minHeight: 70,

    shadowColor: Theme.COLORS.MUTED,
    shadowOffset: {
      width: 0,
      height: 3,
    },
    shadowOpacity: 0.2,
    shadowRadius: 6.65,
    elevation: 4,
  },
  txt: {
    fontSize: 14,
    marginBottom: 10,
  },
});
const mapStateToProps = (state: any) => {
  return {
    scenarioReducer: state.ScenarioReducer,
    AreaReducer: state.AreaReducer,
    appReducer: state.AppReducer,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    add: (model: SmartParking, accessToken: string) => {
      dispatch(Actions.Add(model, accessToken));
    },
    // update: (model: SmartParking, accessToken: string) => {
    //   dispatch(Actions.Update(model, accessToken));
    // },
  };
};
ParkingLotListScreen["navigationOptions"] = ({
  screenProps: { translate },
}: any) => ({
  headerTitle: translate("navigation.ParkingReservation"),
});
// export default connect(mapStateToProps, mapDispatchToProps)(ParkingListScreen);
export default connect(mapStateToProps, null)(ParkingLotListScreen);
